<template>
  <b-row>
  <b-card class="col-sm-12 col-md-6">
    <b-card-title>
      Finished tasks
    </b-card-title>
    <b-row>
      <div class="col-2 mt-2">Year</div>
      <div class="col-2">
        <b-select
          v-model="year"
          @change="supportissues_get"
        >
        <option :value="loopyear" v-bind:key="loopyear" v-for="loopyear in [year-1, year]">
          {{loopyear}}
        </option>
        </b-select>
      </div>
      <div class="col-2 mt-2">Month</div>
      <div class="col-2">
        <b-select
          v-model="month"
          @change="supportissues_get"
        >
        <option :value="loopmonth" v-bind:key="loopmonth" v-for="loopmonth in ['01','02','03','04','05','06','07','08','09','10','11','12']">
          {{loopmonth}}
        </option>
        </b-select>
      </div>
    </b-row>
    <b-row>
      <b-table
        :fields="fields"
        :items="supportissues"
      >
      </b-table>
    </b-row>
    <b-row>
      <div class="col-8"></div>
      <div class="col-4">
        <strong>Total hours: {{ totalHours }}</strong>
      </div>
    </b-row>
  </b-card>
</b-row>
</template>
<script>
const now = new Date();
const fields = [
  { key: 'id', label: 'Issue ID'},
  { key: 'issue_heading', label: 'Heading' },
  { key: 'actual_hours', label: 'Hours ' },
];

export default {
  name: 'Developer',
  created() {
    this.supportissues_get();
  },
  data() {
    return {
      year: now.getFullYear().toString(),
      month: now.getMonth() +1,
      supportissues: [],
      fields: fields,
      totalHours: 0,
    }
  },
  methods: {
    supportissues_get() {
      const filter = {
        issue_closed_date: {
          operator: " BETWEEN ",
          value: ""+this.year+"-"+this.month+"-01' AND '"+this.year+"-"+this.month+"-31",
        }
      }
      this.$store.dispatch('records_readlist', { table_name: 'g_supportissues', filter })
      .then((resp) => {
        this.totalHours = 0;
        for (let i=0;i<resp.data.result.length;i++) {
          this.totalHours += parseInt(resp.data.result[i].actual_hours) || 0;
        }
        this.supportissues = resp.data.result;
      })
    },
  }
}
</script>
<style>
</style>